import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAdminShop, IShop } from "@shared/interfaces/shop.interface";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { JwtService } from "./jwt.service";

@Injectable()
export class ShopService {

  readonly DEFAULT_ADMIN_SHOP: IAdminShop = {
    id: 0,
    active: false,
    name: 'None',
    edit_loading: false,
    edit_name: '',
    edit_active: false,
    edit_mode: false,
    created_at: '',
    updated_at: ''
  }

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ){
    const token = this.jwtService.getTocken() ?? '';
  }

  private get token() {
    return this.jwtService.getTocken() ?? '';
  }             

  get headers(): HttpHeaders {
      return new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.token
      });
  }


  loadShops(search?:string): Observable<IShop[]> {
    let url = environment.apiUrl + `/shops${search?'?search='+search:''}`;
    return this.http.get<IShop[]>(url);
  }

  loadShopsWithProducts(search?:string): Observable<IShop[]> {
    let url = environment.apiUrl + `/shopsWithProductOffer${search?'?search='+search:''}`;
    return this.http.get<IShop[]>(url);
  }

  getСategories() {
    let url = environment.apiUrl + '/categories';
    return this.http.get(url, {});
  }

}